import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'Raphael-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  showMenu:boolean=false;
  constructor() { }

  ngOnInit(): void {
  }

}
